import React from 'react';


const CarrierRentPage = ({ props }) => {

  return (
    <>
      <h1>Půjčovna nosičů</h1>

      <p>
        Pokud potřebujete střešní box nebo nosič kol jen párkrát do roka, máme pro vás ideální řešení - <strong>VYPŮJČTE U NÁS</strong>.
      </p>
      <p>
        Nabízíme k zapůjčení střešní boxy a nosiče kol na tažné zařízení od firmy Hakr.<br />
        Příčníky k zapůjčení k dispozici nejsou.
      </p>

      <h2>Podmínky a ceny pronájmu</h2>
      <ul className="list">
        <li>cena pronájmu je splatná po vrácení nosiče / boxu (kartou nebo odečtem ze zálohy)</li>
        <li>vratná kauce (záloha) dle ceníku je splatná v hotovosti v den zapůjčení</li>
        <li>uvedené ceny jsou včetně DPH, minimální půjčovné 200 Kč</li>
        <li><strong>první den půjčení neúčtujeme</strong>, započítává se každý následující započatý den</li>
        <li><span>Rezervace na tel.: 326 728 002, osobně nebo e-mailem </span><a href="mailto:pujcovna@prondo.cz">pujcovna@prondo.cz</a></li>
      </ul>

      <h2>Střešní box</h2>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Rozměry</th>
            <th>Objem (l)
              <br/>páry lyží
            </th>
            <th>Cena / den
              <br/>(1-9 dní)
            </th>
            <th>Cena / den
              <br/>(10 a více dní)</th>
            <th>Kauce</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td><strong>HAKR Magic line 400</strong>
              <br/><a href="https://www.hakrbrno.cz/autobox-hakr-magic-line-400-sedy-leskly" target="_blank">více info</a>
            </td>
            <td>199x74x42</td>
            <td>400 / 6</td>
            <td>120 Kč</td>
            <td>110 Kč</td>
            <td>3.000&nbsp;Kč</td>
          </tr>
        </tbody>
      </table>

      <h2>Nosič kol na tažné zařízení</h2>
      <table>
        <thead>
          <tr>
      			<th></th>
      			<th>Typ</th>
      			<th>Počet kol</th>
      			<th>Cena / den
              <br/>(1-9 dní)</th>
      			<th>Cena / den
              <br/>(10 a více dní)</th>
      			<th>Kauce</th>
      		</tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>HAKR Trip Middle 3</strong>
              <br/><a href="https://www.hakrbrno.cz/hakr-trip-pro-3-kola-middle" target="_blank">více info</a></td>
            <td>tažné, 13pin</td>
            <td>3</td>
            <td>100 Kč</td>
            <td>90 Kč</td>
            <td>4.000 Kč</td>
          </tr>
        </tbody>
      </table>

    </>
  );

}

export default CarrierRentPage;
